/**
 * Directive: resendEmail
 */
angular.module('acme.common.directive.resendEmail', [
  'ui.bootstrap',
  'acme.common.service.validate'
])
.directive('resendEmail', [ '$uibModal', function($uibModal) {

    return {
      restrict: 'A',
      replace: true,
      templateUrl: 'common/directives/resendEmail/resendEmail.tpl.html',
      scope: {
        template: '@',
        linkTitle: '@',
        email: '=',
        isDisabled: '=',
        // DEV-14441: optional. When on-send is set the result goes to it instead of the
        // 'ResendEmail::Send' event, which ancestor controllers treat as "resend order confirmation".
        onSend: '&',
        modalTitle: '@',
        // DEV-14441: optional. Shows the email prefilled but not editable (resend-only permission).
        emailReadonly: '='
      },
      
      link: function($scope, $element, $attrs) {
        // Modified after controller runs
      },

      controller: ['$scope', '$attrs', function($scope, $attrs) {

        $scope.resendEmail = {

          title: 'Resend Email',
          email: '',

          emailLanguages: [
            {
              "code": "en-nz",
              "name": "English (New Zealand)"
            },
            {
              "code": "en-us",
              "name": "English (United States)"
            },
            {
              "code": "fr-ca",
              "name": "French (Canada)"
            },
            {
              "code": "es-mx",
              "name": "Spanish (Mexico)"
            }
          ],

          preferredLanguage: false,

          init: function() {
            if ($scope.linkTitle) {
              this.title = $scope.linkTitle;
            }

            if ($scope.email) {
              this.email = $scope.email;
            }

            $scope.$on('$destroy', $scope.$watch('email', function(n, o) {
              if (n !== o) {
                console.log('ResendEmail::init', n);
                $scope.resendEmail.email = n;
              }
            }, true));

            this.preferredLanguage = this.emailLanguages[1];
          },

          send: function() {
            
            if ($scope.isDisabled) {
              return;
            }

            this.resendModal = $uibModal.open({
              templateUrl: 'common/includes/'+$scope.template+'.tpl.html',
              resolve: {
                modalTitle: function() {
                  return $scope.modalTitle || 'Resend Order Confirmation';
                },
                emailReadonly: function() {
                  return !!$scope.emailReadonly;
                },
                emailAddress: function() {
                  return $scope.resendEmail.email;
                },
                emailLanguages: function() {
                  return $scope.resendEmail.emailLanguages;
                },
                preferredLanguage: function() {
                  return $scope.resendEmail.preferredLanguage;
                }
              },
              controller: ['$scope', '$uibModalInstance', 'ValidateService', 'modalTitle', 'emailReadonly', 'emailAddress', 'emailLanguages', 'preferredLanguage', function($scope, $uibModalInstance, ValidateService, modalTitle, emailReadonly, emailAddress, emailLanguages, preferredLanguage) {

                $scope.modalTitle = modalTitle;
                $scope.emailReadonly = emailReadonly;

                $scope.model = {
                  valid: true,
                  email: emailAddress,
                  preferredLanguage: preferredLanguage
                };

                $scope.emailLanguages = emailLanguages;

                $scope.errors = [];

                $scope.hasErrors = function() {
                  return ($scope.errors.length > 0);
                };

                $scope.checkEmail = function(email) {
                  return (ValidateService.validate([
                    { email: email }
                  ]));
                };

                $scope.checkValid = function() {
                  $scope.model.valid = (ValidateService.validate([
                    { email: $scope.model.email }
                  ]));
                  return $scope.model.valid;
                };

                $scope.showSend = function() {
                  return true;
                };

                $scope.done = function () {
                  if ($scope.checkValid()) {
                    $scope.success();
                  }else{
                    $scope.errors = [{
                      message: 'Please enter a valid email'
                    }];
                  }
                };

                $scope.cancel = function () {
                  $uibModalInstance.dismiss('cancel');
                };

                $scope.success = function() {
                  $uibModalInstance.close($scope.model);
                };

              }]
            });

            // Invoked when modal completes with close(params)
            this.resendModal.result.then(function (res) {
              var data = { email: res.email, preferredLanguage: res.preferredLanguage };

              // DEV-14441: a consumer-supplied handler replaces the event; never do both.
              if ($attrs.onSend) {
                $scope.onSend(data);
              } else {
                $scope.$emit('ResendEmail::Send', data);
              }
            }, function () {
            });
          }
        };

        $scope.resendEmail.init();
      }]

    };

}]);